module.exports = __webpack_public_path__ + "static/img/2024_activities_moblie.c4b0aa8d.jpeg";